<div class="card mt-4" *ngIf="gotData">
    <div class="card-body pt-4">
        <app-subtitle-hr [title]="title" />
        <i class="pi pi-angle-down button-float" [ngClass]="{'rotate-button': rotate}" (click)="hide()"></i>

        <div class="hide-container" [ngClass]="{'show-container': show}">
            <div>

                <div class="table-container" *ngIf="filterData && kmShell.length > 0; else noData">
                    <table class="tg mt-3">
                        <thead>
                            <tr>
                                <th style="border: none;"></th>
                                <ng-container *ngFor="let lob of filterData">
                                    <th style="white-space: nowrap; padding: 4px 20px"
                                        [rowSpan]="setRowSpan(lob.sectors)" [colSpan]="setColSpan(lob.sectors)">
                                        <p class="m-0 p-0 text-center">
                                            {{ lob.lob.name }}
                                        </p>
                                    </th>
                                </ng-container>
                            </tr>
                            <tr>
                                <th style="border: none;"></th>
                                <ng-container>
                                    <th *ngFor="let r of sectors">
                                        <p style="white-space: nowrap; padding: 4px 20px" class="m-0 p-0 text-center">
                                            {{ r.name }}</p>
                                    </th>
                                </ng-container>

                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let m of months">
                                <ng-container>
                                    <td>{{ m.nameShort }}</td>
                                    <ng-container *ngFor="let km of returnKmMonth(m.id)">
                                        <td *ngFor="let s of km.sectors">
                                            <p class="text-center m-0 p-0">
                                                <!-- {{ s.sector.name }} -->
                                                {{ s.value[0] ? setValue(s.value[0]) : 0 }}
                                            </p>
                                        </td>
                                        <td>
                                            <p class="text-center m-0 p-0">
                                                <!-- {{ km.lob.name }} -->
                                                {{ km.value[0] ? setValue(km.value[0]) : 0 }}
                                            </p>
                                        </td>
                                    </ng-container>
                                </ng-container>
                            </tr>
                            <tr>
                                <td>Totales</td>

                                <ng-container *ngFor="let f of filterData">
                                    <ng-container *ngFor="let s of f.sectors">
                                        <td>
                                            <p class="text-center m-0 p-0">
                                                {{ returnSumaSector(f.lob.id!, s.id!) }}
                                            </p>
                                        </td>
                                    </ng-container>
                                    <td>
                                        <p class="text-center m-0 p-0">
                                            {{ returnSuma(f.lob.id!) }}
                                            <!-- {{ f.lob.name }} -->
                                        </p>
                                    </td>
                                </ng-container>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <ng-template #noData>
                    <div class="row">
                        <div class="col-12">
                            <h3 class="text-center">
                                Nada que mostrar
                            </h3>
                        </div>
                    </div>
                </ng-template>

            </div>
        </div>
    </div>
</div>